<template>
  <div>
    <a-spin tip="Loading..." >
      <div class="spin-content">
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-icon-selector'
    },
    
  },
  data () {
    return {
      
      icons: 'icons'
    }
  },
  
  
}
</script>

<style lang="less" scoped>
.spin-content {
//   border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

  
</style>
